import { AssetsSvgMap } from '@libs/types';
import React from 'react';
import { CommonScreen } from '../../../common/CommonScreen/CommonScreen';
import { ModalWithTimer } from '../../UI/ModalWithTimer/ModalWithTimer';

/** `version` — design version of the widget that shows the screen (`TWidget.version`). */
const CodeTimerScreen = ({ text, version }: { text?: string; version: number | undefined }) => {
    return (
        <ModalWithTimer version={version}>
            <CommonScreen useIcon={false} iconName={AssetsSvgMap.ic_check_circle_thin} fill="purple_100" mainText={text} version={version} />
        </ModalWithTimer>
    );
};
export { CodeTimerScreen };
